<template>
  <div
    class="relative lg:sticky"
    :class="isProfileCard && isQueueCard ? 'top-16' : 'top-24'"
  >
    <div
      v-if="configDashboard"
      class="flex items-center justify-between absolute z-10 p-6 w-full"
    >
      <h4>Quest Card</h4>
      <vs-chip
        transparent
        color="#FBA727"
        class="text-base text-center cursor-pointer"
        @click.native="removeQuestCard"
      >
        Remove
      </vs-chip>
    </div>
    
    <vx-card
      class="overflow-hidden"
      v-if="coachUserData && coachUserData.userType === 'trainee' && compentencyData"
    >
      <vs-row
        class="p-6 pb-0 flex justify-between items-center"
        :class="configDashboard ? 'opacity' : ''"
      >
        <h3 class="mb-1">{{ $t('orgDashboard.userDashboard.activeQuest') }}</h3>
      </vs-row>
      <hr class="my-4" style="clear: both; border-top: #f4f6fb" />
      
      <vs-row :class="configDashboard ? 'opacity' : ''">
        <vs-col>
          <div class="w-full flex flex-col items-center justify-center">
            <!-- Uses a default background if icon fails to load -->
            <vs-avatar class="mb-4" size="60px" :src="compentencyData.icon" />
            <h4 class="text-center font-semibold">{{ compentencyData.comp }}</h4>
          </div>
        </vs-col>
        
        <vs-col class="p-6">
          <vs-row class="flex">
            <!-- Relevancy Circle -->
            <vs-col class="flex flex-col align-items-center justify-center" vs-lg="4" vs-sm="4" vs-xs="12">
              <!-- Added rotate-canvas-wrapper here -->
              <div class="flex align-items-center justify-center rotate-canvas-wrapper">
                <vue-circle
                  :key="`rel-${compentencyData.relevancy}`"
                  :progress="compentencyData.relevancy"
                  :size="80"
                  :reverse="false"
                  line-cap="round"
                  :fill="fill"
                  empty-fill="rgba(0, 0, 0, .1)"
                  :animation-start-value="0.0"
                  :start-angle="0"
                  insert-mode="append"
                  :thickness="10"
                  :show-percent="true"
                />
              </div>
              <h5 class="text-center mt-2">Relevancy</h5>
            </vs-col>

            <!-- Progress Circle -->
            <vs-col class="flex flex-col align-items-center justify-center" vs-lg="4" vs-sm="4" vs-xs="12">
              <!-- Added rotate-canvas-wrapper here -->
              <div class="flex align-items-center justify-center rotate-canvas-wrapper">
                <vue-circle
                  :key="`prog-${compentencyData.progress}`"
                  :progress="compentencyData.progress"
                  :size="80"
                  :reverse="false"
                  line-cap="round"
                  :fill="fill"
                  empty-fill="rgba(0, 0, 0, .1)"
                  :animation-start-value="0.0"
                  :start-angle="0"
                  insert-mode="append"
                  :thickness="10"
                  :show-percent="true"
                />
              </div>
              <h5 class="text-center mt-2">Progress</h5>
            </vs-col>

            <!-- Practice Circle -->
            <vs-col class="flex flex-col align-items-center justify-center" vs-lg="4" vs-sm="4" vs-xs="12">
              <!-- Added rotate-canvas-wrapper here -->
              <div class="flex align-items-center justify-center rotate-canvas-wrapper">
                <vue-circle
                  :key="`prac-${compentencyData.practice}`"
                  :progress="compentencyData.practice"
                  :size="80"
                  :reverse="false"
                  line-cap="round"
                  :fill="fill"
                  empty-fill="rgba(0, 0, 0, .1)"
                  :animation-start-value="0.0"
                  :start-angle="0"
                  insert-mode="append"
                  :thickness="10"
                  :show-percent="true"
                />
              </div>
              <h5 class="text-center mt-2">Practice</h5>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      
      <vs-row class="text-center" :class="configDashboard ? 'opacity' : ''">
        <h4 @click="toCoach" class="w-full skills-btn px-2 py-3 cursor-pointer">
          Skills Details
        </h4>
      </vs-row>
    </vx-card>

    <vx-card v-else class="p-3 md:p-6 overflow-hidden">
      <vs-row class="flex justify-between items-center" :class="configDashboard ? 'opacity' : ''">
        <h3 class="mb-1">{{ $t('orgDashboard.userDashboard.activeQuest') }}</h3>
      </vs-row>
      <hr class="my-2" style="clear: both; border-top: #f4f6fb" />
      <vs-row>
        <vs-col class="flex flex-col items-center justify-center py-4">
          <img class="lg:w-24 w-64 mb-4" src="@/assets/images/temp-img/empty-quest.svg" />
          <h5 class="text-sm text-center mb-4">{{ $t('orgDashboard.userDashboard.noDevelopmentPlans') }}</h5>
          
          <!-- NEW: SSO Button for Coach -->
          <vs-button
            color="#FBA727"
            type="filled"
            class="font-semibold mt-2"
            style="width: 60%; max-width: 180px;"
            @click="toCoach"
          >
            Login to Coach
          </vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import constants from "@/constants";
import VueCircle from "vue2-circle-progress";
import axios from "axios";

export default {
  components: {
    VueCircle,
  },
  data() {
    return {
      editActiveQuestCard: false,
      constants,
      fill: { gradient: ["#4D927F", "#B7DA64"] },
      coachUserData: null,
      compentencyData: null,
    };
  },
  computed: {
    userData() { return this.$store.state.users.data || {}; },
    userWidgets() { return this.$store.state.dashboard.userWidgets; },
    configDashboard() { return this.$store.state.dashboard.configDashboard; },
    isProfileCard() { return this.$store.state.dashboard.isProfileCard; },
    isQueueCard() { return this.$store.state.dashboard.isQueueCard; },
  },
  mounted() {
    this.getCoachUserData();
  },
  methods: {
    getCoachUserData() {
      let cookieEmail = null;
      let cookieOrgId = null;
      
      if (typeof window !== 'undefined' && window.$cookies) {
        cookieEmail = window.$cookies.get('email');
        cookieOrgId = window.$cookies.get('orgId');
      } else if (this.$cookies) {
        cookieEmail = this.$cookies.get('email');
        cookieOrgId = this.$cookies.get('orgId');
      }

      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      const email = cookieEmail || userInfo.email || this.userData.email;

      if (!email) return;

      const orgId = cookieOrgId || this.$route.params.orgId || "default_org";
      const baseUrl = process.env.VUE_APP_API_URL;

      axios.get(`${baseUrl}/api/coach/progress?email=${encodeURIComponent(email)}&org_id=${encodeURIComponent(orgId)}`)
        .then((response) => {
          const res = response.data;
          
          if (res && res.status === "success" && res.data) {
            this.coachUserData = { userType: "trainee" };
            
            // --- FIX 1: Strict Icon Fallback ---
            let dbIcon = res.data.icon;
            if (!dbIcon || dbIcon === "" || dbIcon === "null") { 
               dbIcon = `https://api-core-gateway.getboarded.com/assets/competencies/${res.data.competencyId}.svg`;
            }

            // --- FIX 2: Pass whole numbers (80, 13) directly! ---
            this.compentencyData = {
              comp: res.data.skillName || "Active Goal",
              relevancy: res.data.relevancy || 0,
              progress: res.data.progress || 0, // NO DIVIDE BY 100
              practice: res.data.practice || 0, // NO DIVIDE BY 100
              icon: dbIcon 
            };
          }
        })
        .catch((err) => console.error("API Fetch Error:", err));
    },

    toCoach() {
      let cookieEmail = null;
      if (typeof window !== 'undefined' && window.$cookies) cookieEmail = window.$cookies.get('email');
      else if (this.$cookies) cookieEmail = this.$cookies.get('email');

      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      const email = cookieEmail || userInfo.email || this.userData.email;
      
      if (!email) return;
      
      let user = email.slice(0, email.indexOf("@"));
      window.location.href = `https://api.coach.getboarded.com/oauth/?selectedAccount=${user}`;
    },
    
    removeQuestCard() {
      // FIX: Changed "ACTIVITY_QUEUE" to "ACTIVE_QUEST"
      const questCard = this.userWidgets.find((item) => item.widgetId === "ACTIVE_QUEST"); 
      
      this.$store.dispatch("dashboard/removeWidget", questCard).then(() => {
        for (var i = 0; i < this.userWidgets.length; i++) {
          // FIX: Changed "ACTIVITY_QUEUE" to "ACTIVE_QUEST"
          if (this.userWidgets[i].widgetId === "ACTIVE_QUEST") {
            this.$store.commit("dashboard/REMOVE_WIDGET", i);
          }
        }
        this.$store.commit("dashboard/SHOW_QUEST_CARD", false);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
$bg: #fba62742;
$color: #fba727;
.icon-bg {
  background-color: $bg;
}
.skills-btn {
  color: $color !important;
  background: $bg;
}

.vx-card ::v-deep .vx-card__body {
  padding: 0;
}
.opacity {
  opacity: 0.075;
}

.circle ::v-deep .percent-text {
  font-size: 15px !important;
}

.stick-top {
  top: 6em;
}

.vs-con-table ::v-deep .vs-table--tbody-table {
  min-width: 100%;
}

.vs-con-table {
  width: 100%;
}

.add-btn {
  color: #fff;
  background: $color;
  border-radius: 5em;
}

@media screen and (max-width: 991px) {
  .vs-con-table ::v-deep .vs-table--content {
    width: 100%;
  }
}
</style>

<!-- This global style forces ONLY the canvas to rotate to 12 o'clock. The text stays upright! -->
<style>
  .rotate-canvas-wrapper canvas {
    transform: rotate(-90deg) !important;
    display: block !important;
  }
</style>